import { getAppInfo } from "@src/appV2/NativeAdapters/app.adapter";
import { getCurrentBundleId } from "@src/appV2/NativeAdapters/liveUpdate.adapter";
import { environmentConfig } from "@src/appV2/environment";
import { Platform } from "@src/mobile/utils/platform";
import { useEffect, useState } from "react";

interface AppInfo {
  appVersion: string;
  buildNumber: string;
  bundleId: string | null;
  platform: string;
  environment: string;
  isLoading: boolean;
}

export function useAppInfo(): AppInfo {
  const [appVersion, setAppVersion] = useState(Platform.isMobile ? "—" : (__APP_VERSION__ ?? "—"));
  const [buildNumber, setBuildNumber] = useState("—");
  const [bundleId, setBundleId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function loadInfo() {
      try {
        if (Platform.isMobile) {
          const info = await getAppInfo();
          setAppVersion(info.version);
          setBuildNumber(info.build);
        }

        const currentBundleId = await getCurrentBundleId();
        setBundleId(currentBundleId);
      } catch {
        // App.getInfo() or getCurrentBundleId() failed — keep defaults
      } finally {
        setIsLoading(false);
      }
    }

    void loadInfo();
  }, []);

  return {
    appVersion,
    buildNumber,
    bundleId,
    platform: Platform.platform,
    environment: environmentConfig.REACT_APP_ENVIRONMENT_NAME,
    isLoading,
  };
}
